<template>
  <div>
    <div v-loading="nalaganjeNovegaGesla" class="sprememba-gesla">
      <div class="postavitev-besedila">
        <p class="navadno-besedilo mobile-odmik">
          Varnost je na prvem mestu. Da bi ohranili varnost svojega T-2 uporabniškega računa,
          redno spreminjajte geslo in ga ne uporabljajte na drugih spletnih mestih.
        </p>
        <p v-if="zadnjaSprememba !== null && zadnjaSprememba.length > 10">
          <b>
            Geslo ste nazadnje spremenili {{ zadnjaSprememba.substring(0, 10) }}.
          </b>
        </p>
      </div>
      <div class="postavitev-input">
        <el-form
          label-width="155px"
          @submit.native.prevent="ShraniNovoGeslo"
          :label-position="formaOrientacija"
          class="nova-vrstica-forma custom-labels">
          <el-form-item label="T-2 identiteta (T-2 ID)">
            <el-input placeholder="" v-model="email" :disabled="true"
                      class="pozicija-uporabniski-racun"/>
          </el-form-item>
          <el-form-item label="Trenutno geslo">
            <el-input placeholder="Vnesite trenutno geslo" type="password" v-model="trenutnoGeslo"
                      class="pozicija-trenutno-geslo">
            </el-input>
          </el-form-item>
          <el-form-item label="Novo geslo" style="label: none;">
            <el-input placeholder="Vnesite novo geslo" type="password" v-model="novoGeslo"
                      class="pozicija-novo-geslo" value="FakePSW" id="input-novo-geslo">
              <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashNovoGeslo"
                 @click="PrikazGesel('input-novo-geslo')" v-if="prikazeIkonoNovoGeslo">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                 @click="PrikazGesel('input-novo-geslo')" v-else>
              </i>
            </el-input>
          </el-form-item>
          <el-form-item class="potrjeno-geslo" label="Potrdite novo geslo">
            <el-input placeholder="Ponovno vnesite novo geslo" type="password" v-model="potrjenoGeslo"
                      class="pozicija-potrjeno-geslo" value="FakePSW"
                      id="input-ponovite-geslo">
              <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashPonoviteGeslo"
                 @click="PrikazGesel('input-ponovite-geslo')" v-if="prikazeIkonoPonoviteGeslo">
              </i>
              <i slot="suffix" class="fa fa-eye" id="ikonaEyePonoviteGeslo"
                 @click="PrikazGesel('input-ponovite-geslo')" v-else>
              </i>
            </el-input>
            <validacija-vrednosti
              v-if="!statusValidacije"
              class="mobile-pozicija"
              :prva-vrednost="novoGeslo"
              :druga-vrednost="potrjenoGeslo"
              :style=" potrjenoGeslo ? 'margin-top:0':'margin-top:-45px'"
              v-on:ValidacijaStatus="SpremeniStatus"/>
          </el-form-item>
        </el-form>
      </div>
      <div style="padding-top: 40px;">
        <el-button type="primary" @click="ShraniNovoGeslo" class="gumb-potrdi">
          SPREMENI GESLO
        </el-button>
      </div>
    </div>
    <hr class="hr-stil" v-if="nePrikaziVmesnikaNiStranke"/>
    <div v-loading="pridobivanjeOsebnihPodatkov || nalaganjeNovegaGeslaReset"
         class="odmik-validacija geslo-container"
         v-if="nePrikaziVmesnikaNiStranke">
      <div class="postavitev-vsebine-dvostopenjska-zascita header-section">
        <span class="open-sans-20pt">
          Sprememba gesla
        </span>
        <p class="navadno-besedilo novi-odstavek opis-gesla">
          Ta vmesnik omogoča spreminjanje gesla za različne spletne platforme T-2. Izberite želeno spletno platformo in nastavite novo geslo.
        </p>
      </div>
      <div class="postavitev-input-reset form-container">
        <el-form
          label-width="155px"
          @submit.native.prevent="ShraniNovoGeslo"
          :label-position="formaOrientacija"
          class="nova-vrstica-forma custom-labels">
          <el-form-item label="Spletna platforma" class="storitev-selector">
            <el-select
              v-model="izbranStoritev"
              placeholder="Izberite storitev"
              :style="prikazTabele === '1' ? 'width:330px' : 'width: 100%'"
              @change="onStoritevChange">
              <el-option label="Avditorij" value="avditorij"></el-option>
              <el-option label="T-2 Klub in TV2GO" value="klub"></el-option>
            </el-select>
            <div class="storitev-opis" v-if="izbranStoritev">
              <p v-if="izbranStoritev === 'avditorij'" class="storitev-info">
                <i class="el-icon-info"></i>
                Izbrali ste ponastavitev gesla za Avditorij.
              </p>
              <p v-else-if="izbranStoritev === 'klub'" class="storitev-info">
                <i class="el-icon-info"></i>
                Izbrali ste ponastavitev gesla za T-2 Klub in TV2GO.
              </p>
            </div>
          </el-form-item>
          <div class="form-fields-container" style="padding-top: 10px">
            <el-form-item label="Naročnina" class="form-item">
              <IzbirnikStranke
                :custom-style="prikazTabele === '1' ? 'width:330px' : 'width: 100%'"
                v-on:osvezitevIzbranihPodatkovStranke="GetStranka"/>
            </el-form-item>

            <el-form-item label="Priključek" class="form-item">
              <IzbirnikPrikljuckaSelect
                :custom-style="prikazTabele === '1' ? 'width:330px' : 'width: 100%'"
                @novIzbranPrikljucek="IzbranPrikljucekEvent($event)"
                :izbranPrikljucek="izbranPrikljucek"
                :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
              />
            </el-form-item>
            <el-form-item label="Uporabniško ime" class="form-item">
              <el-input
                disabled
                class="pozicija-novo-geslo"
                v-model="izbranPrikljucek">
                <i
                  slot="suffix"
                  style="cursor: pointer"
                  class="fa fa-copy copy-icon"
                  @click="kopirajUporabniskoIme"
                  title="Kopiraj uporabniško ime">
                </i>
              </el-input>
            </el-form-item>
            <el-form-item label="Novo geslo" class="form-item">
              <el-input
                placeholder="Vnesite novo geslo"
                type="password"
                v-model="novoGesloReset"
                class="pozicija-novo-geslo"
                id="input-novo-geslo-reset">
                <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashNovoGeslo"
                   @click="PrikazGeselReset('input-novo-geslo-reset')" v-if="prikazeIkonoNovoGesloReset">
                </i>
                <i slot="suffix" class="fa fa-eye" id="ikonaEyeNovoGeslo"
                   @click="PrikazGeselReset('input-novo-geslo-reset')" v-else>
                </i>
              </el-input>
            </el-form-item>

            <el-form-item class="potrjeno-geslo form-item" label="Potrdite novo geslo">
              <el-input
                placeholder="Ponovno vnesite novo geslo"
                type="password"
                v-model="potrjenoGesloReset"
                class="pozicija-potrjeno-geslo"
                id="input-ponovite-geslo-reset">
                <i slot="suffix" class="fa fa-eye-slash" id="ikonaEyeSlashPonoviteGeslo"
                   @click="PrikazGeselReset('input-ponovite-geslo-reset')" v-if="prikazeIkonoPonoviteGesloReset">
                </i>
                <i slot="suffix" class="fa fa-eye" id="ikonaEyePonoviteGeslo"
                   @click="PrikazGeselReset('input-ponovite-geslo-reset')" v-else>
                </i>
              </el-input>
              <validacija-vrednosti
                v-if="!statusValidacije"
                class="mobile-pozicija"
                :prva-vrednost="novoGesloReset"
                :druga-vrednost="potrjenoGesloReset"
                :style="potrjenoGesloReset ? 'margin-top:0':'margin-top:-45px; z-index: 1'"
                v-on:ValidacijaStatus="SpremeniStatus"/>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="button-container sprememba-gesla-spletne-platforme">
        <el-button type="primary" @click="ShraniNovoGesloReset" class="gumb-potrdi">
          SPREMENI GESLO
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import Vue from 'vue'
import {
  Table, Checkbox, TableColumn, Input, Button, Form, FormItem, Option, Collapse, CollapseItem, Select, Loading,
  Pagination, MessageBox
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import ValidacijaVrednosti from './ValidacijaVrednosti'
import {
  FormatirajTelefonskoStevilko
} from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import IzbirnikStranke from '../../GlobalneKomponente/IzbirnikStranke.vue'
import IzbirnikPrikljuckaSelect from '../../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {UrejenSeznamPrikljuckov} from '../../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import PrivzetaVrednostLogic from '../../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
import {PrivzetaVrednostTipEnum} from '../../../../../assets/js/Enum/PrivzetaVrednostTipEnum'

Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(FormItem)
Vue.use(Loading)
export default {
  name: 'SpremembaGesla',
  mixins: [PrikazVsebine, PridobiStranko, FormatirajTelefonskoStevilko],
  data () {
    return {
      email: '',
      trenutnoGeslo: '',
      novoGeslo: '',
      potrjenoGeslo: '',
      clientAgent: null,
      nalaganjeNovegaGesla: false,
      formaOrientacija: 'left',
      prikazeIkonoPonoviteGeslo: true,
      prikazeIkonoNovoGeslo: true,
      mejnaSirina: 700,
      smsToken: '',
      preverjanje: false,
      osebniPodatkiTelefonskaStevilka: '',
      pridobivanjeOsebnihPodatkov: true,
      osebniPodatkiSmsTokenLogin: false,
      zadnjaSprememba: null,
      statusValidacije: false,
      change2Fa: false,
      izpisOsebneStevilke: '',
      seznamPrikljuckovGrupirano: [],
      potrjenoGesloReset: '',
      novoGesloReset: '',
      izbranPrikljucek: '',
      nalaganjeNovegaGeslaReset: false,
      prikazeIkonoPonoviteGesloReset: true,
      prikazeIkonoNovoGesloReset: true,
      nePrikaziVmesnikaNiStranke: true,
      izbranaStrankaSapAvditorij: null,
      izbranaStranka: null,
      izbranaStrankaAvditorij: null,
      izbranPrikljucekAvditorij: null,
      izbranStoritev: 'avditorij'
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    ValidacijaVrednosti,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Pagination.name]: Pagination,
    PridobiStranko
  },
  created () {
    this.GetStranka()
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetOsnovneInformacijeUporabnika()
    this.GetUserData()
    this.change2Fa = false
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    kopirajUporabniskoIme () {
      if (this.izbranPrikljucek) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(this.izbranPrikljucek).then(() => {
            const icon = document.querySelector('.copy-icon')
            if (icon) {
              icon.classList.remove('el-icon-document-copy')
              icon.classList.add('el-icon-check')
              icon.style.color = '#67C23A'
              setTimeout(() => {
                icon.classList.remove('el-icon-check')
                icon.classList.add('el-icon-document-copy')
                icon.style.color = ''
              }, 1500)
            }
          })
        } else {
          this.fallbackCopyTextToClipboard(this.izbranPrikljucek)
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Ni podatka za kopiranje'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    fallbackCopyTextToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Kopirano uporabniško ime.'
          this.ShowSuccessMessage(paramObvestilo)
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Napaka pri kopiranju.'
          this.ShowWarningMessage(paramObvestilo)
        }
      } catch (err) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Kopiranje ni uspelo.'
        this.ShowErrorMessage(paramObvestilo)
      }
      document.body.removeChild(textArea)
    },
    onStoritevChange () {
      this.novoGesloReset = ''
      this.potrjenoGesloReset = ''
    },
    GetStranka (podatkiStranke) {
      if (typeof podatkiStranke !== 'undefined' && podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke.id_stranka
        this.GetPrikljuckiDovoljenja(podatkiStranke.id_stranka)
      }
    },
    IzbranPrikljucekEvent (idPrikljucek) {
      this.izbranPrikljucek = idPrikljucek
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissions[]=PRIKLJUCKI']
        this.clientAgent.postWsRequest(
          this,
          'permissions/all',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckovGrupirano = []
      this.seznamVsehPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.results.PRIKLJUCKI.additionalData.filter(x => x.tip_prikljucka !== 'UMTS')
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamVsehPrikljuckov = list
      this.seznamPrikljuckovGrupirano = groupedList
      let shranjenPrivzetPrikljucek =
        PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)
      if (list.find(x => x.id_prikljucek === shranjenPrivzetPrikljucek)) {
        this.izbranPrikljucek = shranjenPrivzetPrikljucek
      } else {
        list.filter(x => x.tip_prikljucka === 'FIX').forEach(prikljucek => {
          this.izbranPrikljucek = prikljucek.id_prikljucek
        })
      }
      if (this.izbranPrikljucek === '') {
        this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      }
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SpremeniStatus (e) {
      this.statusValidacije = e
    },
    Preklici () {
      this.change2Fa = false
      this.preverjanje = !this.preverjanje
      let paramObvestilo = {}
      paramObvestilo.message = 'Zahteva uspešno preklicana.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    PrenosniPodatkiStranka (osebnikPodatki, nalaganje) {
      if (osebnikPodatki.defaultConnectors.length === 0) {
        this.nePrikaziVmesnikaNiStranke = false
      }
      this.osebniPodatkiTelefonskaStevilka = ''
      this.osebniPodatkiTelefonskaStevilka = osebnikPodatki.phone
      this.izpisOsebneStevilke = this.VrniFormatUmtsStevilke(osebnikPodatki.phone)
      this.osebniPodatkiSmsTokenLogin = osebnikPodatki.smsTokenLogin
      this.pridobivanjeOsebnihPodatkov = nalaganje
      this.preverjanje = this.osebniPodatkiSmsTokenLogin
    },
    VklopIzklopDvostopenjskeZascite (event) {
      if (!event && this.osebniPodatkiSmsTokenLogin) {
        MessageBox.confirm(
          'Ali ste prepričani, da želite izklopiti dvostopenjsko zaščito?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.PosljiPotrditveniSms()
          this.change2Fa = true
          this.preverjanje = false
        }).catch((err) => {
          err = null
          this.preverjanje = !this.preverjanje
          this.GetUserData()
        })
      } else if (!this.osebniPodatkiSmsTokenLogin && !event) {
        this.preverjanje = false
      } else {
        this.preverjanje = true
        this.PosljiPotrditveniSms()
        this.change2Fa = true
      }
    },
    PrikazGesel (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-novo-geslo') {
          this.prikazeIkonoNovoGeslo = false
        } else {
          this.prikazeIkonoPonoviteGeslo = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-novo-geslo') {
          this.prikazeIkonoNovoGeslo = true
        } else {
          this.prikazeIkonoPonoviteGeslo = true
        }
      }
    },
    PrikazGeselReset (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-novo-geslo-reset') {
          this.prikazeIkonoNovoGesloReset = false
        } else {
          this.prikazeIkonoPonoviteGesloReset = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-novo-geslo-reset') {
          this.prikazeIkonoNovoGesloReset = true
        } else {
          this.prikazeIkonoPonoviteGesloReset = true
        }
      }
    },
    ShraniNovoGeslo () {
      this.nalaganjeNovegaGesla = true
      if (this.novoGeslo === this.potrjenoGeslo) {
        let param = ['oldPassword=' + this.trenutnoGeslo]
        param.push('password=' + this.novoGeslo)
        if (this.novoGeslo === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli novih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else if (this.trenutnoGeslo.length === 0) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli trenutnega gesla.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else if (this.novoGeslo.length < 8) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Novo geslo mora imeti vsaj 8 znakov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGesla = false
        } else {
          this.clientAgent.postWsRequest(
            this,
            'user/changePassword?',
            param,
            null,
            'SetNovoGesloShranjeno',
            'SetNapakaPriShranjevanju')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli se ne ujemata.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeNovegaGesla = false
      }
    },
    SetNovoGesloShranjeno (podatki) {
      if (podatki.status === 1) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Geslo uspešno posodobljeno.'
        this.ShowSuccessMessage(paramObvestilo)
        this.GetOsnovneInformacijeUporabnika()
        this.nalaganjeNovegaGesla = false
      }
    },
    SetNapakaPriShranjevanju (podatki) {
      this.ShowWarningMessage(podatki)
      this.nalaganjeNovegaGesla = false
    },
    GetOsnovneInformacijeUporabnika () {
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info?',
        param,
        null,
        'SetOsnovneInformacijeUporabnika',
        'ErrMessage')
    },
    SetOsnovneInformacijeUporabnika (podatki) {
      this.email = podatki.email
      this.zadnjaSprememba = podatki.passwordLastSetDate !== null
        ? FormatDatuma.methods.PoenotenIzgledDatuma(podatki.passwordLastSetDate) : null
    },
    PreverjanjeDvostopenjskeZascite () {
      let param = []
      let enabled = this.preverjanje === true ? 1 : 0
      param.push('enabled=' + enabled)
      this.clientAgent.postWsRequest(
        this,
        'user/editSmsTokenLogin?',
        param,
        enabled,
        'SetPreverjanjeDvostopenjskeZascite',
        'ErrMessage')
    },
    SetPreverjanjeDvostopenjskeZascite () {
      let paramObvestilo = {}
      paramObvestilo.message =
        `Dvostopenjska zaščita z SMS geslom uspešno ${this.preverjanje ? 'vklopljena' : 'izklopljena'}.`
      this.ShowSuccessMessage(paramObvestilo)
      this.change2Fa = false
      this.GetUserData()
    },
    PreveriTelefonskoStevilko () {
      let param = ['token=' + this.smsToken]
      this.clientAgent.postWsRequest(
        this,
        'user/verifyPhoneNumber?',
        param,
        null,
        'SetPreveriTelefonskoStevilko',
        'ErrMessage')
    },
    SetPreveriTelefonskoStevilko () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Telefonska številka je bila uspešno preverjena.'
      this.change2Fa = false
      this.ShowSuccessMessage(paramObvestilo)
      this.PreverjanjeDvostopenjskeZascite()
    },
    PosljiPotrditveniSms () {
      let param = []
      this.smsToken = ''
      this.clientAgent.postWsRequest(
        this,
        'user/sendVerificationSms?',
        param,
        null,
        'SetPosljiPotrditveniSms',
        'ErrMessage')
    },
    SetPosljiPotrditveniSms () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno poslan SMS s potrditvenim geslom.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrMessage (podatki) {
      this.ShowWarningMessage(podatki)
    },
    ShraniNovoGesloReset () {
      if (this.izbranStoritev === 'avditorij') {
        this.ShraniNovoGesloAvditorij()
      } else if (this.izbranStoritev === 'klub') {
        this.ShraniNovoGesloKlub()
      }
    },
    ShraniNovoGesloKlub () {
      this.nalaganjeNovegaGeslaReset = true
      if (this.novoGesloReset === this.potrjenoGesloReset) {
        let param = ['novoGeslo=' + this.novoGesloReset]
        param.push('idPrikljucek=' + this.izbranPrikljucek)
        if (this.novoGesloReset === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli novih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGeslaReset = false
        } else if (this.novoGesloReset.length < 8) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Novo geslo mora imeti vsaj 8 znakov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGeslaReset = false
        } else {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/geslo/nastaviNovoGesloServisneStrani?',
            param,
            null,
            'SetNovoGesloShranjenoReset',
            'SetNapakaPriShranjevanju')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli se ne ujemata.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeNovegaGeslaReset = false
      }
    },
    SetNovoGesloShranjenoReset () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Geslo uspešno posodobljeno.'
      this.ShowSuccessMessage(paramObvestilo)
      this.novoGesloReset = ''
      this.potrjenoGesloReset = ''
      this.statusValidacije = false
      this.GetOsnovneInformacijeUporabnika()
      this.nalaganjeNovegaGeslaReset = false
    },
    ShraniNovoGesloAvditorij () {
      this.nalaganjeNovegaGeslaReset = true
      if (this.novoGesloReset === this.potrjenoGesloReset) {
        let param = ['password=' + this.novoGesloReset]
        param.push('idPrikljucek=' + this.izbranPrikljucek)
        if (this.novoGesloReset === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Niste vnesli novih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGeslaReset = false
        } else if (this.novoGesloReset.length < 8) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Novo geslo mora imeti vsaj 8 znakov.'
          this.ShowWarningMessage(paramObvestilo)
          this.nalaganjeNovegaGeslaReset = false
        } else {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/geslo/nastaviNovoGesloAvditorij?',
            param,
            null,
            'SetNovoGesloShranjenoReset',
            'SetNapakaPriShranjevanju')
        }
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Gesli se ne ujemata.'
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeNovegaGeslaReset = false
      }
    }
  }
}
</script>

<style>
/deep/ .el-table th > .cell {
  font-weight: bold;
  color: #080809;
}
</style>
<style scoped src="../../../../../../static/css/moj_profil/varnost.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/SpremembaGesla.vue